// extracted by mini-css-extract-plugin
export default {"verified_part":"buttons_verified_part__BnxOf","verified":"buttons_verified__axJ9U","restart_part":"buttons_restart_part__WQVNQ","restart":"buttons_restart__FNPgE"};